module.exports = __webpack_public_path__ + "static/media/SalesRevenue.b1561905.svg";